<template>
    <div class="thumbnail_img_content_wrap" v-if="photos.length > 0">
        <div class="thumbnail_img_content" v-for="(image,idx) in photos" :key="image.org_url" :class="{'is_del': isDelete}">
            <el-image
                :src="image.org_url"
                @click="runView(idx)"
                style="width: 100px; height: 100px"
                :fit="'cover'"></el-image>
            <el-button type="info" class="del_btn" icon="el-icon-close" circle v-if="isDelete" @click="runDelete({file: image, index: idx})"></el-button>
        </div>
        <viewer :images="photos" :options="options" @inited="inited">
            <img v-for="image in photos" :src="image.org_url" :key="image.org_url" class="hide"/>
        </viewer>
    </div>
</template>

<script>
import Vue from "vue";
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

Vue.use(Viewer)
export default {
    name: "ImageViewerComponent",
    mixins: [],
    components: {
    },
    inject: [],
    provide() {
        return{
        }
    },
    props: {
        photos: {default: () => []},
        isDelete: {default: false,},
        runDelete: {default: () => {}},
    },
    data() {
        return{
            idx: 0,
            options: {
                title: [1, (i) => `${i.alt.replace(/.jpeg|.jpg|.png/, '')}`],
                movable: false,
                loop: false,
                initialViewIndex: 2,
                fullscreen: false,
                // backdrop: false
            },
            $viewer: null,
        }
    },
    beforeRouterEnter() {},
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {},
    computed: {
    },
    methods:{
        inited(viewer) {
            this.$viewer = viewer;
        },
        show() {
            this.$viewer.show();
        },
        runView(idx) {
            this.$viewer.view(idx);
        }
    },
    watch: {

    },
}
</script>

<style lang="scss">
.gallary_image {
    width: 180px;
    height: 180px;
    display: inline;
    margin: 2px 2px;
    cursor: pointer;
}
.el-image{
    margin-right: 5px;
}
.hide {
    display: none;
}
</style>
